<template>
  <div class="checkbox-input" v-bind:class="{ active: isActive }" @click="$emit('toggleActive', offer)">
    <div class="checkbox-box">
    </div>
    <div class="checkbox-text">
      <div class="checkbox-heading">{{ offer.heading }}</div>
      <div class="checkbox-body">
        <span class="bigger" v-if="offer.price">{{ offer.price | formatPrice }}</span> 
        <span v-if="offer.price">€/kk</span>
        <div v-if="offer.info" class="book">{{ offer.info }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: [
    'offer',
    'isActive'
  ],
  filters: {
  },
  data() {
    return {}
  },
  methods: {
  }
}
</script>
